var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIcIncorrect(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7 14C10.866 14 14 10.866 14 7C14 3.13401 10.866 0 7 0C3.13401 0 0 3.13401 0 7C0 10.866 3.13401 14 7 14ZM4.49497 3.50503C4.22161 3.23166 3.77839 3.23166 3.50503 3.50503C3.23166 3.77839 3.23166 4.22161 3.50503 4.49497L6.01005 7L3.50503 9.50503C3.23166 9.77839 3.23166 10.2216 3.50503 10.495C3.77839 10.7683 4.22161 10.7683 4.49497 10.495L7 7.98995L9.50503 10.495C9.77839 10.7683 10.2216 10.7683 10.495 10.495C10.7683 10.2216 10.7683 9.77839 10.495 9.50503L7.98995 7L10.495 4.49497C10.7683 4.22161 10.7683 3.77839 10.495 3.50503C10.2216 3.23166 9.77839 3.23166 9.50503 3.50503L7 6.01005L4.49497 3.50503Z",
    fill: "#EF2605"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcIncorrect);
export default __webpack_public_path__ + "static/media/ic_incorrect.edfbdc0d081b6be117a20617ca7f3d59.svg";
export { ForwardRef as ReactComponent };